<template>
    <div class="record min-height">
        <div class="flex align-center justify-end margin-bottom">
            <router-link to="/admin/recordSms" v-if=" user.user_role === 1">
                <el-button type="primary">短信群发</el-button></router-link>
        </div>
        <el-table
            :data="tableData"
            alig="center"
            border
            header-row-class-name="table-header"
            row-class-name="table-row"
            style="width: 100%"
        >
            <el-table-column label="序号" type="index" width="80"></el-table-column>
            <el-table-column label="短信模版" prop="value" width="150"></el-table-column>
            <el-table-column label="模版内容" prop="label"></el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <router-link :to="`/admin/recordDetail?id=${scope.row.key}`">
                        <el-button class="font-size-sm margin-left-sm" type="text">查看</el-button>
                    </router-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import {smsList} from "@/api/admin";

export default {
    name: "record",
    data() {
        return {
            tableData: [],
            drawer: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", this.$route.path, "发送记录  / ", false, 'icon-shouji');
        this.getList()
    },
    components: {},
    methods: {
        //  获取列表
        async getList() {
            let _list = await smsList()
            this.tableData = _list.data
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.record {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
}

.pople-list {
    span {
        display: block;
        width: 80px;
        margin: 0 10px 10px 0;
        font-size: 14px;
    }
}
</style>